export var getQuoteList = function (response) {
    if (Array.isArray(response))
        return response;
    if (response && Array.isArray(response.data))
        return response.data;
    return [];
};
export var getQuotePagingInfo = function (response) {
    var _a;
    if (!response || Array.isArray(response))
        return null;
    return (_a = response.pagingInfo) !== null && _a !== void 0 ? _a : null;
};
